import {
  Box,
} from '@mui/material';
import clsx from 'clsx';
import useSessionContext from '../../LiveContext/SessionContextProvider/useSessionContext';
import AccountInformation from './AccountInformation';
import Buttons from './Buttons';
import { useOverflowContext } from './Overflow/OverflowContext';
import OverflowProvider from './Overflow/OverflowProvider';
import SessionInformation from './SessionInformation';
import StyledToolBar from './styles';

interface PluginToolbarProps {
  tab: { index: number, updatedAt: number };
  setTab: (value: { index: number, updatedAt: number }) => void;
}

function InnerPluginToolbar(props: PluginToolbarProps) {
  const { tab, setTab } = props;
  const { containerRef } = useOverflowContext();
  const {
    sessionId,
  } = useSessionContext();

  return (
    <StyledToolBar className={clsx({ reduced: !!sessionId })} ref={containerRef}>
      <Box>
        <SessionInformation tab={tab} setTab={setTab} />
        <Buttons />
        <AccountInformation />
      </Box>
    </StyledToolBar>
  );
}

export default function PluginToobar(props: PluginToolbarProps) {
  return (
    <OverflowProvider>
      <InnerPluginToolbar {...props} />
    </OverflowProvider>
  );
}
